import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilityDefaultShippingCostsListResponse } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

export const useDefaultShippingCosts = (enabled: boolean) => {
  return useQuery<ProfitabilityDefaultShippingCostsListResponse, Error>({
    queryKey: ['profitability', 'default-shipping-costs'],
    queryFn: () => adapter.getDefaultShippingCosts(),
    enabled,
    staleTime: 30 * 1000,
  });
};
